import { createContext, useContext, useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'

type PageContextType = {
    title: string
    setTitle
    header: string
    setHeader
}

const PageContext = createContext<PageContextType>({
    title: '',
    setTitle: () => {},
    header: '',
    setHeader: () => {},
})

export const usePage = () => {
    return useContext(PageContext)
}

export const PageContextProvider = ({ children }) => {
    const [title, setTitle] = useState('')
    const [header, setHeader] = useState('')

    useEffect(() => {
        document.title = title ? `${title?.toUpperCase()} | BR1 INFINITE` : 'BR1 INFINITE'
    }, [title])

    return <PageContext.Provider value={{ title, setTitle, header, setHeader }}>{children}</PageContext.Provider>
}

export const Page = (props) => {
    const { setTitle, setHeader } = usePage()
    const { title, header, children, className, ...rest } = props

    /*
      `setHeader` is unconditional so a page can legitimately have no header. It used to skip the
      call when both props were empty, which meant the mobile bar kept showing whatever the previous
      page had put there — so "no header" was not a state a page could actually be in, and the
      landing page had to invent one ("BR1") to avoid inheriting a stale one.
    */
    useEffect(() => {
        if (title) setTitle(title)
        setHeader(header || title || '')
    }, [title, header])

    return <div className={twMerge('page w-full', className)}>{children}</div>
}
